export const dateToLocalISO = (date) => {
  const tzoffset = (new Date(date)).getTimezoneOffset() * 60000; //offset in milliseconds
  return (new Date(new Date(date).getTime() - tzoffset)).toISOString().slice(0, -1);
};
